import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../services/api.service';
import LoginLayout from '../../components/LoginLayout';

const inputStyle = {
  width: '100%',
  height: '42px',
  padding: '0 14px',
  fontSize: '0.9rem',
  color: '#1a1a1a',
  backgroundColor: '#f8f9fa',
  border: '1px solid #ddd',
  borderRadius: '8px',
  outline: 'none',
  transition: 'border-color 0.15s',
  colorScheme: 'light',
  WebkitAppearance: 'none',
};

const PortalLogin = ({ onPortalLogin, onPortalGroupLogin }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await ApiService.portalLogin(username, password);

      if (response.data && response.data.success) {
        const data = response.data.data;
        const user = data.user;
        const token = data.token;
        const organization = data.organization;

        if (data.accountType === 'GROUP') {
          localStorage.setItem('portalGroupToken', token);
          localStorage.setItem('portalGroupAuthenticated', 'true');
          localStorage.setItem('portalGroupUser', JSON.stringify(user));
          localStorage.setItem('portalGroupData', JSON.stringify(data.group || {}));
          if (onPortalGroupLogin) onPortalGroupLogin();
          navigate('/portal/customers');
          return;
        }

        localStorage.setItem('portalToken', token);
        localStorage.setItem('portalUser', JSON.stringify(user));
        localStorage.setItem('portalOrganization', JSON.stringify(organization));

        onPortalLogin({
          id: user.id,
          email: user.email,
          fullName: user.fullName,
          role: user.role,
          organizationId: user.internalOrganizationId,
          organizationName: organization?.name || '',
          // Whether the TC has enabled the document-expiry report for this org (default on).
          docExpiryEnabled: organization?.docExpiryEnabled !== false,
          // Whether the parent TC has Thaklis features enabled (default on). Portal WO create shows
          // only internal services when this is false.
          thaklisEnabled: organization?.thaklisEnabled !== false,
          token: token
        });

        navigate('/portal/dashboard');
      }
    } catch (err) {
      console.error('Portal login failed:', err);
      const errorMessage = err.response?.data?.message || 'Invalid credentials. Please try again.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginLayout
      title="Customer Portal"
      subtitle="View your quotations, work orders, and invoices"
      footerLink={{ text: "Typing Center Staff? Login here", href: "/login" }}
    >
      <div style={{
        width: '100%',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        padding: '28px 28px 32px',
        colorScheme: 'light',
      }}>
        <h2 style={{ fontSize: '1.1rem', fontWeight: 600, color: '#1a1a1a', marginBottom: '20px' }}>
          Sign In
        </h2>

        {error && (
          <div style={{
            padding: '10px 14px', marginBottom: '16px', borderRadius: '8px',
            backgroundColor: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c', fontSize: '0.85rem',
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 500, color: '#555', marginBottom: '6px' }}>
              Username
            </label>
            <input
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              style={inputStyle}
              onFocus={(e) => e.target.style.borderColor = '#999'}
              onBlur={(e) => e.target.style.borderColor = '#ddd'}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 500, color: '#555', marginBottom: '6px' }}>
              Password
            </label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={inputStyle}
              onFocus={(e) => e.target.style.borderColor = '#999'}
              onBlur={(e) => e.target.style.borderColor = '#ddd'}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              height: '44px',
              fontSize: '0.85rem',
              fontWeight: 600,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: '#ffffff',
              backgroundColor: loading ? '#999' : '#1a1a1a',
              border: 'none',
              borderRadius: '8px',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background-color 0.15s',
            }}
            onMouseEnter={(e) => { if (!loading) e.target.style.backgroundColor = '#333'; }}
            onMouseLeave={(e) => { if (!loading) e.target.style.backgroundColor = '#1a1a1a'; }}
          >
            {loading ? 'Signing in...' : 'Login'}
          </button>
        </form>
      </div>
    </LoginLayout>
  );
};

export default PortalLogin;
